<script setup lang="ts">
/*Vue*/
import { reactive, watch } from "vue";

import * as service from "@/services/relatoriosService";
import { fdata } from "@/utils/funcoes";

/*Componentes*/
import Cabecalho from "@/components/ReportView/Cabecalho.vue";

interface IProps {
  clientes?: service.RelClienteDTO[],
  filtros?: string
}

const props = defineProps<IProps>();

interface IItem {
  cpf: string,
  nome: string,
  dataNascimento?: Date,

  clienteId?: number,
  tipo?: string,
  nomeCliente?: string,
  erro?: string
}

let controle = reactive({
  clientes: [] as service.RelClienteDTO[],
  itens: [] as IItem[],
  status: "",
  erro: ""
});

watch(() => props.clientes, async (newValue) => {
  controle.clientes = newValue ?? [];
  await processar();
}, { immediate: true });

async function processar() {

  try {

    controle.itens = [] as IItem[];

    controle.clientes.forEach(e => {

      var jaTem = null;

      if (e.cpf != null && e.cpf != undefined) {
        e.cpf = e.cpf?.replace(/\D/g, ""); // Remove caracteres não numéricos do CPF
      }

      if (e.cpf != null && e.cpf != undefined && e.cpf != "") {
        jaTem = controle.itens.find(a => a.cpf == e.cpf);

        if (jaTem != null) {
          console.log("ja tem: " + e.nome + " " + e.cpf);
          return;
        }
      }
      else {
        console.log("Sem cpf: " + e.nome + " " + e.cpf);
      }

      var item = {
        cpf: e.cpf,
        nome: e.nome,
        dataNascimento: e.dataNascimento,

        clienteId: e.clienteId,
        tipo: "Titular",
        erro: ''
      } as unknown as IItem;

      if (e.cpf == null || e.cpf == undefined || e.cpf == "") {
        item.erro = "Sem CPF";
      }
      

      controle.itens.push(item);


    });

  } catch (error) {
    controle.erro = "erro agrupando";
  }
}


function titulo(item: IItem) {
  if (item.tipo == "Titular") {
    return "Titular";
  }
  else {
    return item.tipo + " de " + item.nomeCliente + " (Cliente: " + item.clienteId + ")";
  }
}

</script>

<template>
  <Cabecalho :Titulo="'Relatório de Clientes - Assistência Seguro'" :Filtros="props.filtros" />

  <div>{{ controle.itens.length }} Registros</div>
  <table class="table table-sm table-hover table-striped table-bordered">
    <thead class="">
      <tr>
        <th class="text-nowrap">Nome</th>
        <th class="text-center">Data Nascimento</th>
        <th class="text-center">CPF</th>
        <th class="text-center">Tipo</th>
        <th class="text-center">Status</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(cliente, idx) in controle.itens" :key="idx" :class="!cliente.cpf ? 'table-warning' : ''">
        <td class="text-start" data-label="Nome" :title="titulo(cliente)"> {{ cliente.nome }} </td>
        <td class="text-center" data-label="Data Nascimento"> {{ fdata(cliente.dataNascimento) }} </td>
        <td class="text-center" data-label="CPF"> {{ cliente.cpf }} </td>
        <td class="text-center" data-label="Tipo"> {{ cliente.tipo }} </td>
        <td class="text-center" data-label="Status"> </td>
      </tr>
    </tbody>
  </table>

 

</template>


<style scoped>
  .table > :not(caption) > * > * {
    padding: 5px 5px;
  }
</style>
